import { render, staticRenderFns } from "./performance-improvement.vue?vue&type=template&id=00e574ca"
import script from "./performance-improvement.vue?vue&type=script&lang=js"
export * from "./performance-improvement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports